import { Component } from "react";
import { ToastContainer } from "react-toastify";
import LayoutWrapper from "./LayoutWrapper";

export class AllContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "createdAt",
        order_direction: "DESC",
        page: 1,
        category: "",
        package_name: "",
        recommended_class: "",
        customer_id: props.store.user?.customer_id,
      },
      data: [],
      rowcount: 0,
      loader: false,
      toggleFilter: false,
      categoryOpts: [],
      gradeOpts: [],
      selectedCategoryObj: {},
      selectedGradeArr: {},
    };
  }

  componentDidMount() {
    this.getAllProducts();
    this.getCategory();
    this.getGrades();
  }

  getAllProducts(params) {
    this.setState({
      loader: true,
    });

    let payload = {
      ...this.state.search,
    };
    const cleanedPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, value]) => value !== undefined)
    );
    console.log({ params, cleanedPayload });

    this.props.api
      .apiGetAllProducts(cleanedPayload)
      .then(({ data, total }) => {
        this.setState({
          data: data,
          rowcount: total,
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }

  getCategory() {
    this.props.api.apiGetSubModules({ usedOnly: true }).then((res) => {
      let categoryOpts = res.data[0]?.records?.map((v) => {
        return {
          ...v,
          key: v?.sub_module_id,
          label: `${v?.sub_module_name} (${v?.curriculum_name})`,
        };
      });
      this.setState({ categoryOpts });
    });
  }

  getGrades() {
    this.props.api.apiGetCurriculumGrades({ usedOnly: true }).then((res) => {
      let gradeOpts = res.data?.options("curriculum_id", "curriculum_grade");
      this.setState({ gradeOpts });
    });
  }

  handleNameChange(e) {
    this.setState(
      {
        search: {
          ...this.state.search,
          package_name: e.target.value,
        },
      },
      () => this.getAllProducts()
    );
  }

  handleCategoryChange(value) {
    let obj = value[0] || {};
    this.setState(
      {
        selectedCategoryObj: obj,
        search: {
          ...this.state.search,
          category: obj?.sub_module_id,
        },
      },
      () => this.getAllProducts()
    );
  }
  handleCategoryClearFilter() {
    document
      .querySelector('[name="appinput-category"]')
      .vnode.refs.select2.clearAll();
  }

  handleGradeChange(arr) {
    this.setState(
      {
        selectedGradeArr: arr || [],
        search: {
          ...this.state.search,
          recommended_class: arr.map((v) => v?.curriculum_id),
        },
      },
      () => this.getAllProducts()
    );
  }
  handleGradeClearFilter(e, record) {
    e.preventDefault();
    e.stopPropagation();
    document.getElementById(`${record?.curriculum_id}`).click();
  }
  render() {
    let { navigate } = this.props;
    let {
      loader,
      data,
      categoryOpts,
      gradeOpts,
      selectedCategoryObj,
      selectedGradeArr,
    } = this.state;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <LayoutWrapper
          title={`Hello ${window.store.getState().root?.user?.full_name}`}
          back="Home / Buy Content"
          backlink="/dashboard"
        >
          <ToastContainer position="top-right" />
          <div className="row">
            <div className="col-8">
              <AppInput
                pattern="^[A-Za-z ]+$"
                type="text"
                name="name"
                placeholder="Search by Name"
                labelClass="text-bold"
                invalidmessage="Please enter a valid name"
                onChange={(...args) => this.handleNameChange(...args)}
              ></AppInput>
            </div>
            <div className="col-4">
              <button
                className="btn btn-success btn-block filter_btn"
                onClick={() =>
                  this.setState({ toggleFilter: !this.state.toggleFilter })
                }
              >
                <span>Filter ({selectedGradeArr?.length || 0})</span>
                <i
                  className={Object.className({
                    "fa fw-bold ms-2": true,
                    "fa-angle-up": this.state.toggleFilter,
                    "fa-angle-down": !this.state.toggleFilter,
                  })}
                ></i>
              </button>
            </div>
          </div>
          {this.state.toggleFilter && (
            <div className="card content_card">
              <div className="row g-4">
                <div className="col-12 col-md-4">
                  <AppInput
                    type="select"
                    name="category"
                    label="Categories"
                    options={categoryOpts || []}
                    onChange={(...args) => this.handleCategoryChange(...args)}
                  ></AppInput>
                </div>
                <div className="col-12 col-md-4">
                  <AppInput
                    type="select"
                    name="grade"
                    label="Grade"
                    options={gradeOpts || []}
                    onChange={(...args) => this.handleGradeChange(...args)}
                    multi="true"
                    itemRenderer={({
                      item,
                      itemIndex,
                      props,
                      state,
                      methods,
                    }) => (
                      <div
                        id={item.key}
                        className="custom_option_container"
                        onClick={() => {
                          methods.addItem(item);
                          console.log(item);
                        }}
                      >
                        <span
                          className={Object.className({
                            "selected current": methods.isSelected(item),
                          })}
                        >
                          {item.label}
                        </span>
                      </div>
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <div className="custom_select_btn_container">
                        {state.values?.length > 0
                          ? state.values?.map((value) => {
                              return (
                                <button
                                  id={value?.key}
                                  type="button"
                                  onClick={(e) => methods.removeItem(e, value)}
                                >
                                  {value.label} X
                                </button>
                              );
                            })
                          : "Select"}
                      </div>
                    )}
                  ></AppInput>
                </div>
                <div className="col-12">
                  {Object.keys(selectedCategoryObj).length > 0 && (
                    <div className="btn-group">
                      <button
                        className="btn btn-outline-primary btn-rounded"
                        onClick={(...args) =>
                          this.handleCategoryClearFilter(...args)
                        }
                      >
                        {selectedCategoryObj?.label} X
                      </button>
                    </div>
                  )}
                  {selectedGradeArr?.length > 0 &&
                    selectedGradeArr?.map((item) => {
                      return (
                        <div className="btn-group">
                          <button
                            className="btn btn-outline-primary btn-rounded me-2"
                            onClick={(...args) =>
                              this.handleGradeClearFilter(...args, item)
                            }
                          >
                            {item?.curriculum_name?.toTitleCase()} X
                          </button>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          <div className="card py-4 category_card_container mb-4">
            {data?.length > 0 && (
              <div className="card-header">
                <h2 className="fs-5"></h2>
                <button className="btn btn-success btn-block filter_btn">
                  <span>View All</span>
                </button>
              </div>
            )}
            <div className="card-body">
              {data &&
                data?.map((item) => {
                  let {
                    package_id,
                    thumbnail_file,
                    package_name,
                    package_description,
                    accessed,
                  } = item;
                  return (
                    <div
                      className="category_card cursor-pointer"
                      onClick={(...args) =>
                        navigate(
                          `/allcontent/allcontentdetails?packageId=${package_id}&packageName=${package_name}&accessed=${accessed}`
                        )
                      }
                    >
                      {accessed && (
                        <div className="ribbon">Already Purchased</div>
                      )}
                      <div className="img_block">
                        <img
                          src={thumbnail_file?.url}
                          className="img-fluid"
                          alt="image"
                        />
                      </div>
                      <div className="content">
                        <h3 className="title">{package_name}</h3>
                        {/* <p className="desc">{package_description}</p> */}
                      </div>
                    </div>
                  );
                })}
            </div>

            {data?.length == 0 && <div className="empty_layout lms"></div>}
          </div>
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(AllContent);
